import React from 'react';
import { Alert, Button, Stack } from '@efast_public/fjd-component-library';
import { useTranslation } from 'react-i18next';
import { FitConnectForm } from './FitConnectForm';
import { BehoerdenpostfachForm } from './BehoerdenpostfachForm';
import { ZustellwegSubFormProps } from './Zustellweg.types';
import { urlToGovosVerfahrenZustellweg } from '../../utils/urlUtil';

export function ZustellwegModalRouter(props: ZustellwegSubFormProps) {
  const { t } = useTranslation();
  let alertHeadline: string = t('EditTransportConfigModal.odmLimitReached');

  if (
    (props.serviceIndex === -1 && (props.zustellwege?.length ?? 0) === 0) ||
    (props.serviceIndex === 0 && (props.zustellwege?.length ?? 0) === 1)
  ) {
    if (props.parentState.selectedZustellwegType === 'a3behoerdenpostfach') {
      return <BehoerdenpostfachForm {...props} />;
    } else if (
      props.parentState.selectedZustellwegType === 'fitcondeliveryservice'
    ) {
      return <FitConnectForm {...props} />;
    }
    alertHeadline = t('ZustellwegModalRouter.unsupportedTypeMessage');
  }

  return (
    <Alert
      variant="info"
      message={
        <Stack direction="column" spacing="l">
          <div>{alertHeadline}</div>
          <Button
            variant="primary-text"
            beforeIcon="arrow-up-right"
            onClick={(e) => {
              e.stopPropagation();
              window.open(
                urlToGovosVerfahrenZustellweg(
                  props.startAppId,
                  props.processId ?? '',
                  props.serviceIndex
                ),
                '_blank'
              );
            }}
            size="sm"
          >
            {t('ManagedOnlinedienstDetail.redirectButton')}
          </Button>
        </Stack>
      }
    />
  );
}
